import { Component } from '@theme/component';

/**
 * The "subject" field isn't a real Shopify contact form field (only name/email/phone/body
 * are supported), so it's folded into the message body as a prefixed note right before
 * the native, non-AJAX form submission goes through.
 *
 * @extends {Component}
 */
class ContactFormComponent extends Component {
  requiredRefs = ['subjectSelect', 'bodyInput'];

  prependSubject() {
    const subject = this.refs.subjectSelect.value;
    if (!subject) return;

    const prefixLabel = this.dataset.subjectPrefix || 'Subject';
    const prefix = `${prefixLabel}: ${subject}\n\n`;

    if (!this.refs.bodyInput.value.startsWith(prefix)) {
      this.refs.bodyInput.value = `${prefix}${this.refs.bodyInput.value}`;
    }
  }
}

if (!customElements.get('contact-form-component')) {
  customElements.define('contact-form-component', ContactFormComponent);
}
